import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TSBreadcrumbItem, TSBreadcrumbItemEvent } from './ts-breadcrumb.types';
@Component({
  selector: 'ts-breadcrumb',
  templateUrl: './ts-breadcrumb.component.html',
  styleUrls: ['./ts-breadcrumb.component.scss'],
})
export class TsBreadcrumbComponent implements OnInit {
  @Input() items: TSBreadcrumbItem[] = [];
  @Output() itemClick: EventEmitter<TSBreadcrumbItemEvent> = new EventEmitter<TSBreadcrumbItemEvent>();

  constructor() {}

  ngOnInit() {}

  onItemClick(event, item: TSBreadcrumbItem) {
    if (item.disabled) {
      event.preventDefault();
      return;
    }

    if (!item.routerLink) {
      event.preventDefault();
    }

    this.itemClick.emit({
      originalEvent: event,
      item,
    });
  }
}
